// AC9. Oldest to newest, with actor, timestamp and channel on every entry - a deal that arrived
// from Teams and one typed into the web UI are different facts about the same deal. The words
// are timeline.js's.

import { describe, eventLabel } from './timeline.js';

export default function DealTimeline({ events }) {
  if (!events?.length) return <p className="muted">Nothing recorded yet.</p>;

  return (
    <ol className="timeline">
      {events.map((event, index) => {
        const words = describe(event);
        return (
          <li key={`${event.occurred_at}-${index}`}>
            <time dateTime={event.occurred_at}>
              {new Date(event.occurred_at).toLocaleString()}
            </time>
            <strong>{eventLabel(event)}</strong>
            <span>{event.actor_display_name || event.actor_user_id}</span>
            <span className="channel">{event.channel}</span>
            {words && <span className="detail">{words}</span>}
          </li>
        );
      })}
    </ol>
  );
}
